module.exports = __webpack_public_path__ + "assets/koenigs_apo_slider1.f691cceb.jpeg";